import { forwardRef, type Ref, type SVGProps } from "react";
function SvgCheckWarning(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={100}
      height={69}
      fill="none"
      {...props}
    >
      <g clipPath="url(#check-warning_svg__a)">
        <circle cx={50} cy={34} r={28.409} stroke="url(#check-warning_svg__b)" strokeWidth={10} />
      </g>
      <path
        stroke="#0C1C43"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={0.568}
        d="m42.898 35.511 3.835 4.262 8.949-11.364"
      />
      <defs>
        <linearGradient
          id="check-warning_svg__b"
          x1={50}
          x2={50}
          y1={5.591}
          y2={62.409}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.195} stopColor="#FFE3C3" />
          <stop offset={1} stopColor="#F6F3F1" />
        </linearGradient>
        <clipPath id="check-warning_svg__a">
          <rect width={56.818} height={56.818} x={21.591} y={5.591} fill="#fff" rx={28.409} />
        </clipPath>
      </defs>
    </svg>
  );
}
const ForwardRef = forwardRef(SvgCheckWarning);
export default ForwardRef;
